var $e23e2c12aa0580ab$exports = {};
$e23e2c12aa0580ab$exports = {
    "Empty": `Tom`
};


export {$e23e2c12aa0580ab$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
